const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const creationDraftId = (search = ''): string | undefined => {
    const parameters = new URLSearchParams(search);
    if (parameters.getAll('draftId').length !== 1) return;
    const id = parameters.get('draftId');
    return id && GUID.test(id) && id !== '00000000-0000-0000-0000-000000000000'
        ? id.toLowerCase() : undefined;
};

export const newCreationLocation = (entryType: number | null) => ({
    pathname: '/create-ticket',
    search: `?draftId=${newRequestIdentity()}`,
    state: { createTicketEntryType: entryType },
});

export const newCreationIntent = (entryType: number | null) => ({
    pathname: '/create-ticket',
    search: `?newRequest=1${entryType === null ? '' : `&entryType=${entryType}`}`,
    state: { createTicketEntryType: entryType },
});

export const newRequestIdentity = (): string => {
    const bytes = new Uint8Array(16);
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        crypto.getRandomValues(bytes);
    } else if (process.env.NODE_ENV === 'test') {
        for (let index = 0; index < bytes.length; index += 1) {
            bytes[index] = Math.floor(Math.random() * 256);
        }
    } else {
        throw new Error('Secure request identity generation is unavailable.');
    }
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
